import React, { useState, useEffect } from 'react';
import { Users, UserPlus, Calendar, User, Clock, Share2, BookOpen, Scale, Shield, AlertTriangle, Phone } from 'lucide-react';
import WhatsAppIcon from '../components/WhatsAppIcon';
import Header from '../components/Header';
import Footer from '../components/Footer';

const BlogPost = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0a3a23]/10 via-white to-[#0a3a23]/5" dir="rtl">
      
      <Header />
      
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] py-12 sm:py-20 mt-20">
        <div className="absolute inset-0 bg-black opacity-40"></div>
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Ccircle cx='7' cy='7' r='5'/%3E%3Ccircle cx='53' cy='7' r='5'/%3E%3Ccircle cx='30' cy='30' r='5'/%3E%3Ccircle cx='7' cy='53' r='5'/%3E%3Ccircle cx='53' cy='53' r='5'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}></div>
        
        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 text-center text-white">
          <div className="flex items-center justify-center gap-2 mb-3 sm:mb-4">
            <BookOpen className="w-4 h-4 sm:w-6 sm:h-6" />
            <span className="text-white font-semibold text-sm sm:text-base">المدونة القانونية</span>
          </div>
          
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-4 sm:mb-6 leading-tight px-2 text-white">
            حماية المستهلك في المملكة العربية السعودية
          </h1>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 text-white text-sm sm:text-base">
            <div className="flex items-center gap-2">
              <Calendar className="w-4 h-4 sm:w-5 sm:h-5" />
              <span>ديسمبر 2025</span>
            </div>
            <div className="flex items-center gap-2">
              <User className="w-4 h-4 sm:w-5 sm:h-5" />
              <span>شركة أنس للمحاماة</span>
            </div>
            <div className="flex items-center gap-2">
              <Clock className="w-4 h-4 sm:w-5 sm:h-5" />
              <span>12 دقيقة قراءة</span>
            </div>
          </div>
        </div>
      </div>

      {/* Article Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-8 sm:py-16">
        <div className="bg-white rounded-xl sm:rounded-2xl shadow-lg overflow-hidden">
          
          {/* Article Header */}
          <div className="p-4 sm:p-8 border-b border-gray-100">
            <div className="bg-[#0a3a23]/10 p-4 sm:p-6 rounded-lg sm:rounded-xl border-l-4 border-[#0a3a23]">
              <p className="text-sm sm:text-base md:text-lg text-[#0a3a23] font-semibold">
                <strong>إشراف: شركة أنس للمحاماة والاستشارات القانونية</strong>
              </p>
            </div>
          </div>

          {/* Introduction */}
          <div className="p-4 sm:p-8">
            <div className="mb-6 sm:mb-8">
              <p className="text-sm sm:text-base md:text-lg leading-relaxed text-gray-800 mb-4 sm:mb-6">
                تعد حماية المستهلك من الركائز الأساسية في أي مجتمع يسعى لتحقيق العدالة الاقتصادية وضمان التوازن بين أطراف العلاقة التعاقدية، وقد أولت المملكة العربية السعودية هذا الجانب أهمية كبيرة من خلال وضع أنظمة وتشريعات تهدف إلى حماية حقوق المستهلك والمحافظة على سلامته من أي ممارسات تجارية مضللة أو ضارة.
              </p>
              
              <p className="text-sm sm:text-base md:text-lg leading-relaxed text-gray-800 mb-4 sm:mb-6">
                تتمثل حماية المستهلك في ضمان حصوله على سلع وخدمات آمنة ومطابقة للمواصفات، مع توفير المعلومات الكافية لاتخاذ قراره الشرائي.
              </p>
            </div>

            {/* Section 1: حقوق المستهلك */}
            <div className="mb-8 sm:mb-12">
              <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
                <Shield className="w-6 h-6 sm:w-8 sm:h-8 text-[#0a3a23]" />
                <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800">من أبرز الحقوق التي يكفلها النظام:</h2>
              </div>
              
              {/* Image */}
              <div className="mb-6 sm:mb-8">
                <img 
                  src="/images/صور الموقع (1)/صورة واتساب بتاريخ 2025-09-02 في 00.31.12_4d4e2450.jpg" 
                  alt="حقوق المستهلك في المملكة العربية السعودية" 
                  className="w-full h-auto object-contain rounded-lg sm:rounded-xl"
                />
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
                <div className="bg-[#0a3a23]/10 p-4 sm:p-6 rounded-lg sm:rounded-xl">
                  <h4 className="font-bold text-[#0a3a23] mb-2 sm:mb-3 text-sm sm:text-base">الحق في الاستبدال أو الاسترجاع</h4>
                  <p className="text-sm sm:text-base text-[#0a3a23]">عند وجود عيب في السلعة، يحق للمستهلك استبدالها أو استرجاعها والحصول على المبلغ المدفوع.</p>
                </div>
                <div className="bg-[#0a3a23]/5 p-4 sm:p-6 rounded-lg sm:rounded-xl">
                  <h4 className="font-bold text-[#0a3a23] mb-2 sm:mb-3 text-sm sm:text-base">الحق في المعلومات</h4>
                  <p className="text-sm sm:text-base text-[#0a3a23]">الحق في الحصول على معلومات صحيحة وواضحة عن المنتج أو الخدمة قبل الشراء.</p>
                </div>
                <div className="bg-[#0a3a23]/10 p-4 sm:p-6 rounded-lg sm:rounded-xl">
                  <h4 className="font-bold text-[#0a3a23] mb-2 sm:mb-3 text-sm sm:text-base">الحماية من الغش التجاري</h4>
                  <p className="text-sm sm:text-base text-[#0a3a23]">الحق في الحماية من الغش التجاري أو التضليل في الإعلانات.</p>
                </div>
                <div className="bg-[#0a3a23]/5 p-4 sm:p-6 rounded-lg sm:rounded-xl">
                  <h4 className="font-bold text-[#0a3a23] mb-2 sm:mb-3 text-sm sm:text-base">المواصفات والمقاييس</h4>
                  <p className="text-sm sm:text-base text-[#0a3a23]">الحق في الحصول على سلع أو خدمات مطابقة للمواصفات والمقاييس المعتمدة.</p>
                </div>
              </div>
            </div>

            {/* Section 2: الأنظمة السعودية */}
            <div className="mb-8 sm:mb-12">
              <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
                <Scale className="w-6 h-6 sm:w-8 sm:h-8 text-[#0a3a23]" />
                <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800">وقد عززت المملكة العربية السعودية هذه الحقوق عبر عدة أنظمة رئيسية:</h2>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6">
                <div className="bg-[#0a3a23]/10 p-4 sm:p-6 rounded-lg sm:rounded-xl">
                  <h4 className="font-bold text-[#0a3a23] mb-2 sm:mb-3 text-sm sm:text-base">نظام حماية المستهلك</h4>
                  <p className="text-sm sm:text-base text-[#0a3a23]">يضع التزامات على الموردين لضمان حقوق المستهلك وحمايته من الممارسات التجارية الضارة.</p>
                </div>
                <div className="bg-[#0a3a23]/5 p-4 sm:p-6 rounded-lg sm:rounded-xl">
                  <h4 className="font-bold text-[#0a3a23] mb-2 sm:mb-3 text-sm sm:text-base">نظام مكافحة الغش التجاري</h4>
                  <p className="text-sm sm:text-base text-[#0a3a23]">يجرّم تداول السلع المغشوشة أو غير المطابقة للمواصفات ويعاقب المخالفين.</p>
                </div>
                <div className="bg-[#0a3a23]/10 p-4 sm:p-6 rounded-lg sm:rounded-xl">
                  <h4 className="font-bold text-[#0a3a23] mb-2 sm:mb-3 text-sm sm:text-base">نظام هيئة الغذاء والدواء</h4>
                  <p className="text-sm sm:text-base text-[#0a3a23]">يحمي المستهلك من أي منتجات غذائية أو دوائية تمس صحته وسلامته.</p>
                </div>
              </div>
            </div>
            
            {/* Section 3: العقوبات */}
            <div className="mb-8 sm:mb-12">
              <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
                <AlertTriangle className="w-6 h-6 sm:w-8 sm:h-8 text-red-600" />
                <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800">العقوبات المقررة للمخالفين:</h2>
              </div>
              
              <div className="bg-red-50 p-4 sm:p-6 rounded-lg sm:rounded-xl border-l-4 border-red-500">
                <ul className="space-y-2 sm:space-y-3 text-sm sm:text-base text-red-800">
                  <li className="flex items-start gap-2 sm:gap-3">
                    <span className="w-2 h-2 bg-red-500 rounded-full mt-2 flex-shrink-0"></span>
                    <span><strong>غرامات مالية:</strong> قد تصل إلى ملايين الريالات.</span>
                  </li>
                  <li className="flex items-start gap-2 sm:gap-3">
                    <span className="w-2 h-2 bg-red-500 rounded-full mt-2 flex-shrink-0"></span>
                    <span><strong>إغلاق المحلات:</strong> إغلاق المحلات المخالفة وسحب التراخيص.</span>
                  </li>
                  <li className="flex items-start gap-2 sm:gap-3">
                    <span className="w-2 h-2 bg-red-500 rounded-full mt-2 flex-shrink-0"></span>
                    <span><strong>مصادرة السلع:</strong> مصادرة وإتلاف السلع المغشوشة أو غير المطابقة.</span>
                  </li>
                </ul>
              </div>
            </div>
            
            {/* Call to Action */}
            <div className="bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] p-6 sm:p-8 rounded-xl sm:rounded-2xl text-white text-center">
              <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-white mb-3 sm:mb-4">هل تحتاج استشارة في قضايا حماية المستهلك؟</h3>
              <p className="text-white/90 mb-4 sm:mb-6 text-sm sm:text-base">
                تواصل مع شركة أنس للمحاماة للحصول على استشارة قانونية متخصصة في قضايا حماية المستهلك
              </p>
              <a
                href="https://wa.me/966115115945?text=أريد استشارة قانونية في قضايا حماية المستهلك"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-white text-[#0a3a23] px-6 sm:px-8 py-2 sm:py-3 rounded-lg font-bold hover:bg-gray-100 hover:shadow-lg transition-all duration-300 text-sm sm:text-base"
              >
                احجز استشارة الآن
              </a>
            </div>

            {/* Author Section */}
            <div className="mt-8 sm:mt-12 bg-gradient-to-r from-[#0a3a23]/10 to-[#0a3a23]/5 p-4 sm:p-6 rounded-lg sm:rounded-xl border-l-4 border-[#0a3a23]">
              <div className="flex items-center">
                <p className="text-sm sm:text-base text-[#0a3a23] font-semibold">
                  <strong>إعداد: شيماء نبيل</strong>
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Share Section */}
        <div className="mt-6 sm:mt-8 text-center">
          <div className="flex items-center justify-center gap-3 sm:gap-4 mb-3 sm:mb-4">
            <Share2 className="w-5 h-5 sm:w-6 sm:h-6 text-gray-600" />
            <span className="text-gray-600 font-semibold text-sm sm:text-base">شارك المقال</span>
          </div>
          <div className="flex justify-center gap-3 sm:gap-4">
            <a
              href="https://x.com/khayatlawfirm?t=jAXcLytECVDZ2DRxkSLPWg&s=09"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#0a3a23] text-white px-4 sm:px-6 py-2 rounded-lg hover:bg-[#0a3a23]/90 transition-colors text-sm sm:text-base"
            >
              تويتر
            </a>
            <a
              href="https://www.instagram.com/khayatlawfirm?igsh=MTRmNXByeDBnOGxucw=="
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#0a3a23] text-white px-4 sm:px-6 py-2 rounded-lg hover:bg-[#0a3a23]/90 transition-colors text-sm sm:text-base"
            >
              انستجرام
            </a>
          </div>
        </div>
      </div>

      {/* Floating Contact Buttons */}
      <a
        href="tel:920033053"
        className="fixed bottom-20 sm:bottom-28 left-4 sm:left-6 bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] text-white p-3 sm:p-4 rounded-full shadow-2xl hover:shadow-[#0a3a23]/25 transition-all duration-300 z-50 hover:scale-110"
      >
        <Phone className="w-5 h-5 sm:w-6 sm:h-6" />
      </a>

      {/* Floating WhatsApp Button */}
      <a
        href="https://wa.me/966115115945?text=أريد استشارة قانونية في قضايا حماية المستهلك"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-4 sm:bottom-6 left-4 sm:left-6 bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] text-white p-3 sm:p-4 rounded-full shadow-2xl hover:shadow-[#0a3a23]/25 transition-all duration-300 z-50 hover:scale-110"
      >
        <WhatsAppIcon className="w-5 h-5 sm:w-6 sm:h-6" />
      </a>

      <Footer />
    </div>
  );
};

export default BlogPost;
